import React, { useState } from 'react';
import { Row, Col, Button, Card as BSCard } from 'reactstrap';

import DataStore from '../base/plumbing/DataStore';
import { getType } from '../base/data/DataClass';
import C from '../C';

import { Card } from '../base/components/CardAccordion';
import PropControl from '../base/components/PropControl';
import KWorkflow from './KWorkflow';
import NGO from '../base/data/NGO';



/* <BSCard body className="mb-2">
	<h5>Longer text for ads running on the Good-Loop landing page. @Roscoe - Is this still used at all??</h5>
	<Row>
		<Col sm="6"><PropControl item={b} path={bpath} type="textarea" label="Thank you message (html OK)" prop="tq" /></Col>
		<Col sm="6">
			<PropControl item={b} path={bpath} type="textarea" label="About sponsor/campaign (html OK)" prop="about"
				help="Suggestion: a few words to describe the brand/site, then why you picked these charities."
			/>
		</Col>
	</Row>
</BSCard> */

/**
 * Static-banner (image/video) controls for advertiser/publisher editor
 */
function BannerControls({entity, ...other}) {
	const epath = DataStore.getDataPath({status: C.KStatus.DRAFT, type: getType(entity), id: entity.id});
	const vidPath = epath.concat('bannerVideos');
	const imgPath = epath.concat('bannerImages');
	
	const [show, setShow] = useState(false);

	const content = show ? <>
		<div className="well">
			<h4>Image Banners</h4>
			<Row>
				{Object.keys(C.ADSIZEINFO).map(adsize => (
					<Col sm="6" md="4" lg="3">
						<PropControl key={adsize} type="imgUpload" path={imgPath} prop={adsize} label={C.ADSIZEINFO[adsize]} version="standard" />
					</Col>
				))}
			</Row>
		</div>
		<div className="well">
			<h4>Video Banners</h4>
			<Row>
				{Object.keys(C.ADSIZEINFO).map(adsize => (
					<Col sm="6" md="4" lg="3">
						<PropControl key={adsize} type="videoUpload" path={vidPath} prop={adsize} label={C.ADSIZEINFO[adsize]} />
					</Col>
				))}
			</Row>
		</div>
	</> : null;

	return (
		<Card title="Static Banners" {...other}>
			{content}
			<Button onClick={() => setShow(!show)}>{show ? 'Hide' : 'Show Static Banner Controls'}</Button>
		</Card>
	);
}


/** Event tags and descriptions for OnXControls */
const onX = {
	render: 'render',
	render2: 'render2 (landing page)',
	open: 'open',
	startvideo: 'start video',
	minview: 'minview',
	pick: 'charity pick',
	click: 'click',
	endvideo: 'end video',
};

function OnXControls({path}) {
	const pathadv = path.concat('advanced');
	return (
		<BSCard body className="mb-2">
			<p>URLs (aka pixels) or script tags to be called on events in the advert lifecycle. You can set several, separating them with ", ".</p>
			<Row>
				{Object.entries(onX).map(([evt, desc]) => (
					<Col key={evt} sm="6" md="3">
						<PropControl label={`On ${desc}`} prop={`on${evt}`} type="textarea" path={pathadv} />
					</Col>
				))}
			</Row>
		</BSCard>
	);
}



export { BannerControls, OnXControls };
